'use strict';
/* ==========================================================================
   levels/map.js — the hub: the SCIENCE FAIR (DESIGN.md §1–§2). On the blueprint wall, one pinned poster card per
   lesson.json step (so a new step shows up by itself): a colored header band (law blue, theory amber …), a round
   number seal, the step title in slab type, the tag in hand lettering and a little law / theory / graph doodle. A
   finished step gets a TESTED stamp (its score when Game.progress.scores[id] = {best, of}); the first step not done
   yet gets a red grease-pencil "next!" arrow. Dr. Voss stands at the left with a speech bubble.
   → Game.replace(new Levels[id]()). On a phone held upright the steps are full-width rows in the portrait dock
   (Dock.map) and the wall is only the picture (no hit areas, no bubble).
   QA: Levels.map.tags() → [{id, x, y}] (tools/integration.js clicks them).
   ========================================================================== */
(function () {
  const F = () => window.Fair;
  const CARD_W = 300, CARD_H = 420, ROW_Y = 630;
  // each card's header color + doodle, by position (a 5th step would reuse the first)
  const LOOK = [
    { color: () => F().C.law, doodle: 'cards' },
    { color: () => F().C.red, doodle: 'board' },
    { color: () => F().C.blueDeep, doodle: 'graph' },
    { color: () => F().C.amberDeep, doodle: 'notes' },
  ];
  // Dr. Voss's line on the map (captions only; no VO for the map)
  const SAY = {
    hello: 'Four cards. Start with card one. Bring your ladder; we\'ll fix it.',
    next: 'Tested and stamped. The next card is marked.',
    done: 'All four tested. Different jobs, and you can do both.',
  };

  function tags() {
    const S = (Game.lesson && Game.lesson.steps) || [], n = Math.max(1, S.length);
    const x0 = 700, x1 = 1680, gap = n > 1 ? (x1 - x0) / (n - 1) : 0, w = Math.min(CARD_W, gap ? gap - 26 : CARD_W);
    let k = 0;
    return S.map((s, i) => {
      const stamps = s.stamp !== false; if (stamps) k++;
      const look = LOOK[i % LOOK.length];
      return { id: s.id, n: stamps ? k : null, title: s.title, sub: s.tag || '', w: Math.round(w), h: CARD_H, x: n > 1 ? x0 + i * gap : 1190,
        y: ROW_Y + [0, -14, 8, -6][i % 4], rot: [-0.03, 0.02, -0.015, 0.025][i % 4], color: look.color(), doodle: look.doodle };
    });
  }
  const nextStep = () => tags().find(tg => tg.n != null && !Game.progress.stamps[tg.id]);

  function doodle(kind, x, y, seed) {
    const Fa = F(), C = Fa.C;
    if (kind === 'cards') {
      paperRect(x - 46, y, 80, 54, C.law, { seed: seed + 1, depth: 0.5, rot: -0.06, boil: false });
      paperRect(x + 46, y + 2, 80, 54, C.amber, { seed: seed + 2, depth: 0.5, rot: 0.05, boil: false });
      g.font = "22px 'Alfa Slab One'"; g.textAlign = 'center'; g.textBaseline = 'middle';
      g.fillStyle = C.cream; g.fillText('WHAT', x - 46, y + 2); g.fillStyle = C.ink; g.fillText('WHY', x + 46, y + 4);
    } else if (kind === 'board') {
      paperRect(x, y, 90, 64, C.cream, { seed: seed + 3, depth: 0.5, boil: false });
      paperRect(x - 64, y + 4, 36, 58, '#e8dcc0', { seed: seed + 4, depth: 0.4, boil: false });
      paperRect(x + 64, y + 4, 36, 58, '#e8dcc0', { seed: seed + 5, depth: 0.4, boil: false });
      ink([[x - 30, y - 14], [x + 30, y + 14]], { w: 5, color: C.red, seed: seed + 6, passes: 1 });
      inkCircle(x, y, 26, { w: 4, color: C.red, seed: seed + 7, sx: 1.3 });
    } else if (kind === 'graph') {
      paperRect(x, y, 150, 80, C.graph, { seed: seed + 8, depth: 0.5, boil: false });
      ink([[x - 62, y + 30], [x + 66, y + 30]], { w: 3, color: C.ink, seed: seed + 9, passes: 1 });
      ink([[x - 62, y + 30], [x - 62, y - 34]], { w: 3, color: C.ink, seed: seed + 10, passes: 1 });
      ink([[x - 60, y + 28], [x + 60, y - 30]], { w: 3, color: C.red, seed: seed + 11, passes: 1 });
      [[-44, 20], [-20, 8], [10, -6], [44, -22]].forEach(([dx, dy], i) => { g.beginPath(); g.arc(x + dx, y + dy, 6, 0, TAU); g.fillStyle = C.blueDeep; g.fill(); });
    } else {
      // a music staff with notes (the song)
      for (let i = 0; i < 5; i++) ink([[x - 70, y - 24 + i * 12], [x + 70, y - 24 + i * 12]], { w: 2, color: C.ink, seed: seed + 12 + i, passes: 1 });
      [[-40, 6], [-6, -12], [30, 0]].forEach(([dx, dy], i) => { g.beginPath(); g.ellipse(x + dx, y + dy, 9, 7, -0.4, 0, TAU); g.fillStyle = C.ink; g.fill(); ink([[x + dx + 8, y + dy], [x + dx + 8, y + dy - 40]], { w: 3, color: C.ink, seed: seed + 20 + i, passes: 1 }); });
    }
  }

  function drawCard(tg, i, hover, s, t0) {
    const C = F().C;
    if (s <= 0) return;
    g.save();
    g.translate(tg.x, tg.y + (hover ? -8 : 0)); g.rotate(tg.rot + (hover ? -0.012 : 0)); g.scale(s * (hover ? 1.03 : 1), s * (hover ? 1.03 : 1));
    paperRect(0, 0, tg.w, tg.h, C.cream, { seed: 40 + i * 9, depth: hover ? 2 : 1.3 });
    paperRect(0, Math.round(-tg.h / 2 + 34), tg.w - 10, 60, tg.color, { seed: 44 + i * 9, depth: 0, boil: false });
    tape(0, -tg.h / 2 - 4, 120, 0.04 * (i % 2 ? 1 : -1), undefined, 50 + i);
    // the number seal
    if (tg.n != null) {
      paperCircle(-tg.w / 2 + 50, -tg.h / 2 + 96, 40, C.red, { seed: 46 + i * 9, depth: 0.7 });
      g.font = "58px 'Luckiest Guy'"; g.textAlign = 'center'; g.textBaseline = 'middle'; g.fillStyle = C.cream;
      g.fillText(String(tg.n), -tg.w / 2 + 50, -tg.h / 2 + 101);
    }
    // the title in slab type on the header band (wrapped to two lines if needed)
    const words = String(tg.title).toUpperCase();
    F().fitFont(words, tg.w - 34, 34, "'Alfa Slab One'"); g.textAlign = 'center'; g.textBaseline = 'middle'; g.fillStyle = C.cream;
    g.fillText(words, 0, -tg.h / 2 + 34);
    // the tag in hand lettering, wrapped
    const size = Math.min(40, UI.text(34)), lines = (UI._wrap ? UI._wrap(tg.sub, tg.w - 40, `${size}px 'Caveat Brush'`) : [tg.sub]).slice(0, 3);
    lines.forEach((l, k) => hand(l, 0, -30 + k * size * 1.05, size, t0 + 0.8 + i * 0.12, { color: C.navy, seed: 58 + i * 5 + k }));
    doodle(tg.doodle, 0, tg.h / 2 - 90, 300 + i * 40);
    g.restore();
  }

  class MapScene extends Scene {
    enter() {
      const st = Game.progress.stamps, T_ = tags().filter(tg => tg.n != null);
      this.allDone = T_.every(tg => st[tg.id]);
      this.say = this.allDone ? SAY.done : T_.some(tg => st[tg.id]) ? SAY.next : SAY.hello;
      this.stampNew = Game._justStamped; Game._justStamped = null;
      Audio.play('paper', { gain: 0.5 });
      if (Game.MUSIC) Audio.music(Game.MUSIC, { gain: 0.3 });
    }
    open(id) {
      Audio.play('pop', { gain: 0.6 });
      const Cls = Levels[id];
      if (typeof Cls === 'function') Game.replace(new Cls());
      else UI.toast('coming soon');
    }
    keyDown(k) {
      const all = tags(), n = parseInt(k, 10);
      if (n >= 1 && n <= all.length) this.open(all[n - 1].id);
      if (k === 'Enter') this.open((nextStep() || all[0]).id);
    }

    draw() {
      UI.allLessons();                       // "← All lessons": back to the site's home page (core/ui.js)
      const t0 = this.enteredAt, t = this.t, docked = UI.docked(), Fa = F(), C = Fa.C;
      Fa.backdrop();
      Fa.floor(930);
      ransom('THE SCIENCE FAIR', 1190, 120, 76, t0 + 0.15, { seed: 303 });
      hand('the school gym · table 4', 1190, 232, 44, t0 + 0.5, { color: C.cream, seed: 306, outline: 'rgba(37,60,90,0.85)' });

      // Dr. Voss + speech (the speech goes into the dock when docked)
      const rise = E.outBack(P(T, t0 + 0.2, t0 + 0.7), 1.4);
      Puppet.draw('voss', 240, 1080 + (1 - rise) * 520, 640, { facing: 1, t: T, pose: this.allDone ? 'point' : null, env: t > 0.6 && t < 3 ? 0.25 + 0.25 * Math.sin(T * 17) : 0 });
      if (docked) Dock.map({ say: this.say, who: (LessonHooks.speakers && LessonHooks.speakers.voss || {}).name, open: id => this.open(id) });
      else if (t > 0.6) UI.speech(this.say, 330, 250, { side: 'left', w: 440, t0: t0 + 0.6 });

      const nx = nextStep();
      tags().forEach((tg, i) => {
        const hit = docked ? { hover: false, clicked: false } : UI._hit('tag' + i, tg.x, tg.y, tg.w, UI.tap(tg.h));
        if (hit.hover && !this['hov' + i]) Audio.play('paper', { gain: 0.2, rate: 1.3 });
        this['hov' + i] = hit.hover;
        drawCard(tg, i, hit.hover, pop(T, t0 + 0.35 + i * 0.12, 0.4, 2.2), t0);
        if (Game.progress.stamps[tg.id]) {
          let ss = 1;
          if (this.stampNew === tg.id) {
            const at = t0 + 0.9;
            ss = pop(T, at, 0.18, 1.2) * (1 + 1.4 * (1 - P(T, at, at + 0.12)));
            if (T >= at && !this.stampPlayed) { this.stampPlayed = true; Audio.play('stamp'); }
          } else ss = pop(T, t0 + 0.8, 0.25, 1.5);
          const sc = Game.progress.scores && Game.progress.scores[tg.id];
          const lab = (Game.lesson.completeCard && Game.lesson.completeCard.title) || 'TESTED';
          UI.stamp(sc && sc.best != null && sc.of ? `${sc.best}/${sc.of}` : lab, tg.x, tg.y + tg.h * 0.1, { rot: -0.2, s: ss * 0.46, color: C.red });
        }
        if (!this.allDone && !docked && nx && nx.id === tg.id) {   // docked: the dock row says next!
          const ns = pop(T, t0 + 1.4, 0.4), bob = Math.sin(T * 4) * 8;
          if (ns > 0) {
            g.save(); g.globalAlpha = ns;
            const ay = tg.y - tg.h / 2 - 20 - bob;
            inkArrow(tg.x + 80, ay - 90, tg.x + 14, ay, { w: 6, color: C.red, seed: 600 + i, bulge: -18 });
            hand('next!', tg.x + 128, ay - 106, 44, 0, { dur: 0.01, color: C.red, rot: 0.08, seed: 610 + i, outline: 'rgba(251,245,230,0.9)' });
            g.restore();
          }
        }
        if (hit.clicked) this.open(tg.id);
      });
    }
  }
  MapScene.tags = () => tags().map(tg => ({ id: tg.id, x: tg.x, y: tg.y }));   // tools/integration.js clicks these

  Levels.map = MapScene;
})();
